import { checkPropTypes } from "prop-types";

const initialState = {
    mainCategory : null,
    subCategory : null
}; 

const categoryReducer = (state = initialState, action)=> {
    switch(action.type) {

        case 'MAIN_CATEGORY_LOAD_SUCCESS' : {
            return {
                ...state,
                mainCategory : [
                    ...action.payload.categories
                ]
            }
        }break;
        case 'SUB_CATEGORY_LOAD_SUCCESS' : {
            return {
                ...state,
                subCategory : [
                    ...action.payload.subCategories
                ]
            }
        }break;
        default : {
            return state;
        }break;
    }
}

export default categoryReducer;



// WEBPACK FOOTER //
// ./src/reducers/categoryReducer.js